<template>
  <div
    ref="textContainer"
    :style="componentStyle"
    :class="['animated', { [conf.anim]: conf.anim }]"
  >
  <!-- @dblclick="handleDbClick" -->
    <div ref="textRef" :style="scaleStyle" v-if="!isChangeEdit">
      <div ref="text1" :class="[{ oneline: isOneLine }]">
        <text-float :conf="conf" />
        <text-float v-show="isShowHorizontal" :conf="conf" />
      </div>
      <div v-show="isShowVertical">
        <text-float :conf="conf" />
      </div>
    </div>
    <div v-else>
      <el-input
        ref="ta"
        v-model="conf.text"
        type="textarea"
        :style="taStyle"
        @blur="editing = false"
      />
    </div>
  </div>
</template>

<script>
import eventbus from "../../../utils/eventbus";
import store from "../../../store";
import textFloat from "./textFloat.vue";

export default {
  name: "TumengText",
  components: {
    textFloat,
  },
  props: {
    conf: {
      type: Object,
      default: () => {},
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editing: false,
      // 这个防抖用 16ms只能调用一次
      time: Number.MIN_SAFE_INTEGER,
      textWidth: 1,
    };
  },
  computed: {
    scaleStyle() {
      return {};
    },
    componentStyle() {
      const { clipShap } = this.conf;
      const borderRadius = `${clipShap.leftTop}% ${clipShap.rightTop}% ${clipShap.rightBottom}% ${clipShap.leftBottom}%`;
      return {
        width: "100%",
        height: "100%",
        position: "relative",
        top: 0,
        userSelect: "none",
        display: "flex",
        padding: this.conf.padding + "px",
        justifyContent: this.conf.textAlign,
        alignItems: this.conf.verticalAlign,
        lineHeight: this.conf.lineHeight + "",
        fontSize: this.conf.fontSize + "px",
        color: this.conf.fontColor,
        backgroundColor: this.conf.bgColor,
        transformOrigin: this.conf.transformOrigin,
        transform: "rotate(" + this.conf.rotate + "deg)",
        fontWeight: this.conf.isBold ? "bold" : "normal",
        fontStyle: this.conf.isItaly ? "italic" : "normal",
        textDecoration: this.conf.isUnderline,
        fontFamily: `'${this.conf.font}'`,
        whiteSpace:
          this.conf.exceedingDisplay == "autoWrap" ? "normal" : "nowrap",
        writingMode: this.conf.editDirection ? "vertical-lr" : "inherit",
        borderRadius: borderRadius,
        overflow: "hidden",
      };
    },
    taStyle() {
      return {
        height: this.conf.height + "px",
        fontSize: "24px",
      };
    },
    isShowVertical() {
      return (
        this.conf.scrollDirection === "up" ||
        this.conf.scrollDirection === "down"
      );
    },
    isShowHorizontal() {
      return (
        this.conf.scrollDirection === "left" ||
        this.conf.scrollDirection === "right"
      );
    },
    isOneLine() {
      return (
        this.conf.scrollDirection === "left" ||
        this.conf.scrollDirection === "right"
      );
    },
    isChangeEdit() {
      if (store.state.activeComponent) {
        return (
          this.conf.componentId === store.state.activeComponent.componentId &&
          this.editing
        );
      }
      return this.editing;
    },
  },
  watch: {
    "conf.text"() {
      this.conf.text = this.conf.text
        .replace(/\r\n/g, "#line#")
        .replace(/\n/g, "#line#")
        .replace(/\t/g, "#line#")
        .replace(/'/g, "#mark#")
        .replace(/\"/g, "#marks#");
      this.scrollAnimation();
    },
    "conf.width"() {
      this.scrollAnimation();
    },
    "conf.height"() {
      this.scrollAnimation();
    },
    "conf.textDecoration"(val) {
      console.log(val);
    },
  },
  filters: {
    htmlFix(html) {
      return html
        .replace(/#line#/g, "\n")
        .replace(/#mark#/g, "'")
        .replace(/#marks#/g, '"');
    },
  },
  created() {
    this.scrollAnimation();
    if (!this.preview) {
      this.$watch(
        () => {
          return this.conf.scrollDirection;
        },
        () => {
          this.scrollAnimation();
        }
      );
    }

    eventbus.$on("click-component", (id) => {
      if (this.editing && id === this.conf.id) {
        // this.$refs.ta.focus()
      }
    });
    this.$once("beforeDestroy", () => {
      eventbus.$off("click-component");
    });
  },
  methods: {
    handleDbClick() {
      if (!this.preview) {
        this.editing = true;
        setTimeout(() => {
          this.$refs.ta.focus();
        }, 100);
      }
    },
    scrollAnimation() {
      if (Date.now() < this.time) {
        return;
      }
      this.time = Date.now() + 16;
      setTimeout(() => {
        if (this.conf.scrollDirection) {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
          }
          const listWrapper = this.$refs.textContainer;
          const noticeList1 = this.$refs.text1;

          const _subStr = (str) => {
            const index = str.indexOf("px");
            if (index > -1) {
              return parseFloat(str.substr(0, index + 1));
            }
          };

          const sd = this.conf.scrollDirection;
          if (sd === "up") {
            listWrapper.style.top = "0px";
            listWrapper.style.left = "0px";
            this.intervalId = setInterval(() => {
              if (
                Math.abs(_subStr(listWrapper.style.top)) >=
                noticeList1.clientHeight
              ) {
                listWrapper.style.top = "0px";
              } else {
                const top = listWrapper.style.top;
                listWrapper.style.top =
                  (-1 * this.conf.speed) / 20 + _subStr(top) + "px";
              }
            }, 16);
          } else if (sd === "down") {
            listWrapper.style.top = -1.0 * noticeList1.clientHeight + "px";
            listWrapper.style.left = "0px";
            this.intervalId = setInterval(() => {
              if (_subStr(listWrapper.style.top) >= 0) {
                listWrapper.style.top = -1.0 * noticeList1.clientHeight + "px";
              } else {
                const top = listWrapper.style.top;
                listWrapper.style.top =
                  this.conf.speed / 20 + _subStr(top) + "px";
              }
            }, 16);
          } else {
            // 判断宽度有没有超出，没有超出没办法滚动
            if (noticeList1.scrollWidth / 2 > listWrapper.clientWidth) {
              if (sd === "left") {
                listWrapper.style.left = "0px";
                listWrapper.style.top = "0px";
                this.intervalId = setInterval(() => {
                  if (
                    _subStr(listWrapper.style.left) <
                    (-1.0 * noticeList1.scrollWidth) / 2
                  ) {
                    listWrapper.style.left = "0px";
                  } else {
                    const left = listWrapper.style.left;
                    listWrapper.style.left =
                      (-1 * this.conf.speed) / 20 + _subStr(left) + "px";
                  }
                }, 16);
              } else if (sd === "right") {
                listWrapper.style.left =
                  (-1 * noticeList1.scrollWidth) / 2 + "px";
                listWrapper.style.top = "0px";
                this.intervalId = setInterval(() => {
                  if (_subStr(listWrapper.style.left) > 0) {
                    listWrapper.style.left =
                      (-1 * noticeList1.scrollWidth) / 2 + "px";
                  } else {
                    const left = listWrapper.style.left;
                    listWrapper.style.left =
                      this.conf.speed / 20 + _subStr(left) + "px";
                  }
                }, 16);
              }
            }
          }
        } else {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
            const listWrapper = this.$refs.textContainer;
            listWrapper.style.top = "0px";
            listWrapper.style.left = "0px";
          }
        }
      }, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.oneline {
  word-break: keep-all;
  white-space: nowrap;
  display: flex;
}

.el-textarea {
  ::v-deep .el-textarea__inner {
    height: 100%;
  }
}
</style>
